export default __webpack_public_path__ + "static/media/icon_settings.84a363dd.svg";